// Culling-Only identity — frontend mirror of backend/app/culling.py.
// Keep the two in sync: the same four frozen labels, the same precedence
// (line_items -> products -> product_name), the same exact-match rule.
//
// Why the fallback matters here: PROJECTS_LIST_PROJECTION (server.py) does NOT
// include `line_items`, so a project object taken straight from the board list
// has only products/product_name. The drawer later refetches the full doc from
// GET /projects/{id} (which does include line_items). Both shapes must resolve
// identically, which is what the fallback chain guarantees.

// The four canonical labels: pricing.js NLE_OPTIONS + the 'NLE TBD' fallback.
// EXACT match only — 'culling' also appears in the per-image Photo Culling
// product and in the photo-bundle culling add-on, which are NOT this product.
export const CULLING_ONLY_LABELS = [
  'Culling Only (Adobe Premiere)',
  'Culling Only (DaVinci Resolve)',
  'Culling Only (Final Cut Pro)',
  'Culling Only (NLE TBD)',
];

// Accepted culling deliverable extensions — mirror of
// backend/app/culling.py::CULLING_DELIVERABLE_EXTS. Kept separate from the photo
// deliverable list; the backend re-validates, this is just early UX feedback.
export const CULLING_DELIVERABLE_EXTS = [
  '.prproj', '.drp', '.drt', '.fcpbundle', '.fcpxml', '.xml', '.aaf', '.edl', '.zip',
];

export const extOf = (name) => '.' + ((name || '').split('.').pop() || '').toLowerCase();

const isCullingLabel = (label) => CULLING_ONLY_LABELS.includes((label || '').trim());

/**
 * True when this project's ENTIRE deliverable is a culling pass, meaning it
 * delivers an NLE project file instead of a review video.
 * Mirrors backend app/culling.py::is_culling_only.
 */
export function isCullingOnly(project) {
  if (!project || typeof project !== 'object') return false;
  if ((project.project_type || 'video') === 'photo') return false;

  const items = project.line_items || [];
  if (items.length) {
    if (items.length !== 1) return false; // mixed/multi-item is not a pure culling job
    return isCullingLabel((items[0] || {}).label);
  }

  const products = project.products || [];
  if (products.length) {
    if (products.length !== 1) return false;
    return isCullingLabel(products[0]);
  }

  return isCullingLabel(project.product_name);
}
